import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Spinner,
  VStack,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useCallback } from 'react';
import { getPackages, searchPackages } from '../../../api/packages';
import usePackageStore from '../../../store/packageStore';
import { useNavigate } from 'react-router-dom';
import { PackageCard } from './PackageCard';
import useStore from '../../../store/store';
import { SearchIcon } from '@chakra-ui/icons';
import { InputGroup, InputLeftElement, Text } from '@chakra-ui/react';

export const PopularPackages = () => {
  const { packages, setPackages } = usePackageStore();

  const { loading, setLoading } = useStore();
  const toast = useToast();
  const navigate = useNavigate();
  React.useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getPackages();
      setPackages(res);
    } catch (error) {
      toast({ duration: 5000, status: 'error', title: error.message, isClosable: true });
    } finally {
      setLoading(false);
    }
  }, [setLoading, setPackages, toast]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = async e => {
    e.preventDefault();
    const res = await searchPackages(e.target.value);
    setPackages(res);
  };

  return (
    <VStack
      p={[5, 12]}
      spacing={[12]}
      height={'full'}
      width="full"
      position="relative"
      overflow="hidden"
      bg="gray.50"
    >
      {/* Background Decorative Element */}
      <Box
        position="absolute"
        bottom="-10%"
        left="-5%"
        width="350px"
        height="350px"
        bg="purple.50"
        borderRadius="full"
        filter="blur(100px)"
        zIndex={0}
        opacity={0.6}
      />

      <Flex flexDir={'column'} gap={[6, 8]} alignItems={'center'} width="full" zIndex={1}>
        <VStack spacing={2}>
          <Heading
            bgGradient="linear(to-r, teal.600, blue.600)"
            bgClip="text"
            fontSize={[32, 42]}
            fontWeight="bold"
            textAlign="center"
          >
            Health Checkup Packages
          </Heading>
          <Text color="gray.500" fontSize={['sm', 'md']} textAlign="center" fontWeight="medium">
            Save more with our comprehensive health screenings
          </Text>
        </VStack>

        <InputGroup width={['90vw', '45vw']} size="lg">
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="teal.500" />
          </InputLeftElement>
          <Input
            variant="filled"
            placeholder="Search for a health package..."
            bg="white"
            borderRadius="full"
            boxShadow="0 4px 12px rgba(0,0,0,0.05)"
            _focus={{
              bg: 'white',
              boxShadow: '0 0 0 3px rgba(49, 151, 149, 0.2)',
              borderColor: 'teal.400',
            }}
            _hover={{
              bg: 'gray.50',
            }}
            onChange={handleSearch}
          />
        </InputGroup>
      </Flex>

      <Box width="full" px={[0, 10]} zIndex={1}>
        <Box
          display="grid"
          gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
          gap={[6, 8]}
          width="full"
          justifyContent="center"
        >
          {loading ? (
            <Flex width="full" height="40vh" alignItems="center" justifyContent="center" gridColumn="1 / -1">
              <Spinner
                size={'xl'}
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.100"
                color="teal.500"
              />
            </Flex>
          ) : (
            <>
              {packages.slice(0, 3).map((item) => {
                return (
                  <Flex key={item._id || item.id} justify="center">
                    <PackageCard packages={item} />
                  </Flex>
                );
              })}
            </>
          )}
        </Box>
      </Box>

      <Button
        variant={'outline'}
        colorScheme={'teal'}
        size="lg"
        borderRadius="full"
        px={10}
        onClick={() => navigate('/packages')}
        _hover={{
          bg: 'teal.500',
          color: 'white',
          transform: 'translateY(-2px)',
          boxShadow: 'lg',
        }}
        transition="all 0.3s"
        zIndex={1}
      >
        View All Packages
      </Button>
    </VStack>
  );
};
